// extracted by mini-css-extract-plugin
module.exports = {"inner":"loading_inner_1ZZFY","bg":"loading_bg_Kkl6e","img":"loading_img_3t-0x"};